import React from 'react';
import { Route } from 'react-router';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

export default (
  <Route
    key="holiday"
    path="holiday"
    props={{
      pageViewEvent: {
        pageName: MParticlePageName.Holiday,
      },
    }}
    getComponent={(_location, cb) => {
      import(
        /* webpackChunkName: 'marketplace' */
        '../components/discovery/holiday_sale_grid'
      ).then(m => cb(null, m.HolidaySaleGrid));
    }}
  />
);
